import { userManager } from '../context/AuthContext';

export const useLogout = () => {
  const logout = async () => {
    try {
      // signoutRedirect invalida la sesión en el IdP.
      // AuthContext escucha el evento "userUnloaded" y limpia el estado local.
      await userManager.signoutRedirect();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return logout;
};
